module.exports = __webpack_public_path__ + "static/img/usinessPartner_02.3c46ee6a.jpg";